import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DanhMucService, KhachHangTreoThaoService, DatetimeService, UserService } from '../../../../services/index'
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/components/common/message';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
const userLocalName = environment.LOCAL_USER_NAME;

@Component({
  selector: 'app-thongtintkh',
  templateUrl: './thongtintkh.component.html',
  styleUrls: ['./thongtintkh.component.scss'],

  encapsulation: ViewEncapsulation.None
})
export class ThongTinKHComponent implements OnInit, OnDestroy {

  constructor(
    private danhMucService: DanhMucService,
    private treothaoService: KhachHangTreoThaoService,
    private datetimeService: DatetimeService,
    private user: UserService,
    private router: Router,
    private confirmationService: ConfirmationService) {
  }

  @Input() meterid: number;
  @Input() locdulieu: string;
  @Output() reloadDsKH = new EventEmitter();

  modelKH: any = [];
  subscription: Subscription;
  isShowProgress = 0;
  msgs: Message[] = [];

  //Danh sách chủng loại
  listChungLoai: any = [];

  //Danh sách loại module RF
  listLoaiRF: any = [];

  //Danh sách cấu hình cảnh báo
  listCauhinhcanhbao: any = [];

  //Danh sách dự án
  listDuan: any = [];

  //Index công tơ được chọn
  congtoIndex: number = 0;
  isApproveSua = false;

  taiLaiDS_KH() {
    this.reloadDsKH.emit(null)
  }

  ngOnInit() {

    this.isShowProgress = 1;
    this.layDS_Cauhinhcanhbao();
    this.layDS_Duan();
    this.laydulieu();
    this.subscription = this.danhMucService.navItem$.subscribe(
      item => this.CaythumucSelected(item)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  //Lấy danhmucid từ cây thư mục
  CaythumucSelected(item) {

    if (item.treeid == 'donvi')
      this.modelKH.danhmucid = item.value;
    if (item.treeid == 'bennhan')
      this.modelKH.donvinhan = item.value;


  }

  //Lấy danh sách chủng loại
  layDS_ChungLoai() {
    this.treothaoService.layDanhSachLoaiCongTo().subscribe(response => {
      var res = (response).result;
      if (res == "OK") {
        let ret = (response).data;
        this.listChungLoai = ret[0].result_table_0;
        this.listLoaiRF = ret[1].result_table_1;
      }
    });
  }

  //Lấy danh cấu hình cảnh báo
  layDS_Cauhinhcanhbao() {
    this.treothaoService.layDSCauhinhcanhbao().subscribe(response => {
      var res = (response).result;
      if (res == "OK") {
        let ret = (response).data;
        this.listCauhinhcanhbao = ret;
      }
    });
  }

  //Lấy danh dự án
  layDS_Duan() {
    this.treothaoService.layDSDuan().subscribe(response => {
      var res = (response).result;
      if (res == "OK") {
        let ret = (response).data;
        this.listDuan = ret;
      }
    });
  }

  laydulieu() {

    this.isShowProgress = 1;
    this.msgs = [];
    this.treothaoService.layTT_KH(this.meterid).subscribe(res => {
      let dataRet = (res);
      if (dataRet.data.length > 0) {
        this.modelKH = dataRet.data[0];
        this.modelKH.ngaylap = this.datetimeService.strToDatetime(this.modelKH.ngaylap, 'DD/MM/YYYY HH:mm:ss');
        this.modelKH.ngaynghiemthu = this.datetimeService.strToDatetime(this.modelKH.ngaynghiemthu, 'DD/MM/YYYY HH:mm:ss');
        this.modelKH.ngaythanhly = this.datetimeService.strToDatetime(this.modelKH.ngaythanhly, 'DD/MM/YYYY HH:mm:ss');
        this.modelKH.ngaymatdien = this.datetimeService.strToDatetime(this.modelKH.ngaymatdien, 'DD/MM/YYYY HH:mm:ss');
      }
      else {
      }
      this.isShowProgress = 0
    });

  }

  luuTT_KH() {

    this.user.kiemTraQuyen(17).subscribe(
      res => {
        let data = (res).data;
        if (data.length > 0) {
          if (data[0].sua > 0) {
            let message = 'Lưu thông tin điểm đo này ?';
            if (this.locdulieu == "CÓ DỮ LIỆU" && this.modelKH.matdien == 1)
              message = 'Điểm đo đã có dữ liệu, vẫn cập nhật trạng thái MẤT ĐIỆN cho điểm đo này ?'
            let bl = window.confirm(message);
            if (bl) {
              this.isShowProgress = 1;
              this.msgs = [];
              let curUser = JSON.parse(localStorage.getItem(userLocalName));
              this.treothaoService.suaTT_KH(
                this.modelKH.meterid,
                this.modelKH.danhmucid,
                this.modelKH.makhachhang,
                this.modelKH.madiemdo,
                this.modelKH.tenkhachhang,
                this.modelKH.diachi,
                this.modelKH.macongto,
                this.modelKH.macot,
                this.modelKH.matram,
                this.modelKH.masoghi,
                this.modelKH.sapxep,
                this.modelKH.donvinhan,
                this.modelKH.ghichu,
                this.modelKH.maduan,
                this.modelKH.marepeater,
                this.modelKH.congsuattram,
                this.modelKH.ucao,
                this.modelKH.uha,
                this.modelKH.kenh,
                this.modelKH.matdien,
                this.modelKH.nghiemthu,
                this.modelKH.macauhinhcanhbao,
                this.modelKH.loaipha,
                curUser.mataikhoan,
                ''
              ).subscribe(res => {
                debugger;
                let dataRet = (res);
                if (dataRet.result == 'OK' && dataRet.data[0].result == 'ok') {
                  this.msgs.push({ severity: 'success', summary: 'Thông báo', detail: 'Lưu thông tin khách hàng thành công' });
                }
                else {
                  this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lưu dữ liệu: ' + dataRet.data[0].result });
                }
                this.isShowProgress = 0;
                this.taiLaiDS_KH();
              });
            }
          } else {
            alert("Bạn không có quyền thực hiện chức năng này!");
          }

        }
        else {
          alert("Bạn không có quyền thực hiện chức năng này!");

        }
      }
    )

  }
}





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-kh/thongtintkh.component.ts